// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_hz-7";
export var emphasizeQuantity = "_hz-3";
export var flatBottomCorners = "_hz-5";
export var productImage = "_hz-0";
export var quantityContainer = "_hz-2";
export var quantityHeader = "_hz-6";
export var tooltip = "_hz-1";
export var wrapAndEllipsesOverflow = "_hz-4";